import { showFromFade } from "../../js/Util";

if ($(".js-trial-form-wrapper").length) {
    $(".js-trial-form-wrapper")
        .each((index, item) => {
            const start =
                $(document).width() >= 768
                    ? "top bottom-=20%"
                    : "top bottom-=10%";
            showFromFade(item, start);
        });
}